import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "uploadButton", "status", "imageUrlInput", "hiddenInput", "preview"]
  static values = { endpoint: String }

  connect() {
    this.idleStatus("Selecione uma imagem e clique em Enviar para S3.")
    this.syncPreview()
  }

  async upload(event) {
    event.preventDefault()

    if (!this.endpointValue) {
      this.errorStatus("Endpoint de upload não configurado.")
      return
    }

    const file = this.fileInputTarget?.files?.[0]
    if (!file) {
      this.errorStatus("Escolha uma imagem antes de enviar.")
      return
    }

    this.setLoading(true)
    this.idleStatus("Enviando imagem para S3...")

    try {
      const formData = new FormData()
      formData.append("file", file)

      const response = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          Accept: "application/json"
        },
        body: formData
      })

      const payload = await response.json().catch(() => ({}))
      if (!response.ok) {
        const message = Array.isArray(payload?.errors) ? payload.errors.join(" ") : "Falha ao enviar imagem."
        throw new Error(message)
      }

      if (!payload?.url) {
        throw new Error("Upload concluído sem URL pública.")
      }

      this.imageUrlInputTarget.value = payload.url
      this.imageUrlInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.imageUrlInputTarget.dispatchEvent(new Event("change", { bubbles: true }))

      if (this.hasHiddenInputTarget && payload?.signed_id) {
        this.hiddenInputTarget.value = payload.signed_id
        this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
      }

      this.syncPreview()

      this.successStatus("Imagem enviada com sucesso. URL preenchida automaticamente.")
    } catch (error) {
      this.errorStatus(error?.message || "Não foi possível enviar a imagem.")
    } finally {
      this.setLoading(false)
    }
  }

  syncPreview() {
    if (!this.hasPreviewTarget || !this.hasImageUrlInputTarget) return

    const url = (this.imageUrlInputTarget.value || "").trim()
    if (!url) {
      this.previewTarget.classList.add("hidden")
      this.previewTarget.removeAttribute("src")
      return
    }

    this.previewTarget.src = url
    this.previewTarget.classList.remove("hidden")
  }

  setLoading(isLoading) {
    if (!this.hasUploadButtonTarget) return

    this.uploadButtonTarget.disabled = isLoading
    this.uploadButtonTarget.textContent = isLoading ? "Enviando..." : "Enviar para S3"
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  idleStatus(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
    this.statusTarget.className = "text-xs text-slate-500"
  }

  successStatus(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
    this.statusTarget.className = "text-xs text-emerald-700"
  }

  errorStatus(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
    this.statusTarget.className = "text-xs text-red-600"
  }
}
